import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./CustomerAddress.css";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { AddressDetailsAction } from "../Redux/AddressDetailsRedux";
import { UpdateCartData2Action } from "../Redux/CartRedux";

function CustomerAddress(props) {
  const dispatch = useDispatch();
  const posts = useSelector((state) => state.Cart);
  const [errors, setErrors] = useState({});
  const [DataEntered, setDataEntered] = useState({
    Name: "",
    Address: "",
    Landmark: "",
    State: "",
    City: "",
    PinCode: "",
    MobileNo: "",
  });

  useEffect(() => {
    setDataEntered({ ...DataEntered, ...posts.data2 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [posts.data2]);

  const onDataChange = (e) => {
    let Tmp = {};
    Tmp[e.target.name] = e.target.value;
    setDataEntered({ ...DataEntered, ...Tmp });
  };

  const SubmitData = () => {
    //add validation
    const errors = {};
    if (DataEntered.PinCode.length === 0) {
      errors.PinCode = "Enter PinCode";
    } else if (DataEntered.PinCode.length !== 6) {
      errors.PinCode = "Invaid PinCode";
    } else if (!/^\d+$/.test(DataEntered.PinCode)) {
      errors.PinCode = "PinCode is not Number";
    }
    if (DataEntered.MobileNo.length === 0) {
      errors.MobileNo = "Enter MobileNo";
    } else if (DataEntered.MobileNo.length !== 10) {
      errors.MobileNo = "Invalid MobileNo";
    } else if (!/^\d+$/.test(DataEntered.MobileNo)) {
      errors.MobileNo = "MobileNo is not Number";
    }
    if (DataEntered.City.length === 0) {
      errors.City = "Enter City";
    }
    if (DataEntered.State.length === 0) {
      errors.State = "Enter State";
    }
    if (DataEntered.Landmark.length === 0) {
      errors.Landmark = "Enter Landmark";
    }
    if (DataEntered.Address.length === 0) {
      errors.Address = "Enter Address";
    }
    if (DataEntered.Name.length === 0) {
      errors.Name = "Enter Name";
    }
    setErrors(errors);
    if (Object.keys(errors).length === 0) {
      dispatch(AddressDetailsAction(DataEntered));
      //   dispatch(SendCartAction(["None", ""]));//Update it directly to redux data2 if backend replies success or there will be issue some time data wont be called or old data will be updated
      dispatch(UpdateCartData2Action({ ...DataEntered }));
    }
  };

  return (
    <Modal {...props} aria-labelledby="contained-modal-title-vcenter" size="lg">
      <Modal.Header closeButton className="Titel02">
        <Modal.Title id="contained-modal-title-vcenter">
          Address Details
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="ArtBox04">
        <div className="input-group">
          <span className="input-group-text" id="basic-addon2">
            Name
          </span>
          <input
            type="text"
            name="Name"
            className="form-control TextInput"
            placeholder="Enter Your Good Name"
            aria-describedby="basic-addon2"
            value={DataEntered["Name"]}
            onChange={(e) => onDataChange(e)}
          ></input>
        </div>
        {errors.Name && (
          <div className=" d-flex justify-content-center ZeroMargin RedFont">
            {errors.Name}
          </div>
        )}
        <div className="input-group ">
          <span className="input-group-text" id="basic-addon3">
            Address
          </span>
          <textarea
            className="form-control  TextInput"
            name="Address"
            placeholder="Address"
            aria-describedby="basic-addon3"
            value={DataEntered["Address"]}
            onChange={(e) => onDataChange(e)}
            type="text"
          ></textarea>
        </div>

        {errors.Address && (
          <div className=" d-flex justify-content-center ZeroMargin RedFont">
            {errors.Address}
          </div>
        )}
        <div className="input-group ">
          <span className="input-group-text" id="basic-addon4">
            Landmark
          </span>
          <textarea
            className="form-control TextInput "
            name="Landmark"
            placeholder="Landmark"
            type="text"
            aria-describedby="basic-addon4"
            value={DataEntered["Landmark"]}
            onChange={(e) => onDataChange(e)}
          ></textarea>
        </div>

        {errors.Landmark && (
          <div className=" d-flex justify-content-center ZeroMargin RedFont">
            {errors.Landmark}
          </div>
        )}
        <div className="input-group ">
          <span className="input-group-text" id="basic-addon5">
            State
          </span>
          <input
            className="form-control TextInput "
            name="State"
            placeholder="State"
            type="text"
            aria-describedby="basic-addon5"
            value={DataEntered["State"]}
            onChange={(e) => onDataChange(e)}
          ></input>
        </div>

        {errors.State && (
          <div className=" d-flex justify-content-center ZeroMargin RedFont">
            {errors.State}
          </div>
        )}

        <div className="input-group ">
          <span className="input-group-text" id="basic-addon8">
            City
          </span>
          <input
            className="form-control TextInput "
            name="City"
            placeholder="City"
            aria-describedby="basic-addon8"
            type="text"
            value={DataEntered["City"]}
            onChange={(e) => onDataChange(e)}
          ></input>
        </div>
        {errors.City && (
          <div className=" d-flex justify-content-center ZeroMargin RedFont">
            {errors.City}
          </div>
        )}
        <div className="input-group">
          <span className="input-group-text" id="basic-addon1">
            PinCode
          </span>
          <input
            type="number"
            name="PinCode"
            className="form-control NumberInput"
            placeholder="PinCode"
            aria-describedby="basic-addon1"
            value={DataEntered["PinCode"]}
            onChange={(e) => {
              onDataChange(e);
            }}
          ></input>
        </div>
        {errors.PinCode && (
          <div className=" d-flex justify-content-center ZeroMargin RedFont">
            {errors.PinCode}
          </div>
        )}
        <div className="input-group">
          <span className="input-group-text" id="basic-addon1">
            MobileNo
          </span>
          <input
            type="number"
            name="MobileNo"
            className="form-control NumberInput"
            placeholder="Contact Number"
            aria-describedby="basic-addon1"
            value={DataEntered["MobileNo"]}
            onChange={(e) => {
              onDataChange(e);
            }}
          ></input>
        </div>
        {errors.MobileNo && (
          <div className=" d-flex justify-content-center ZeroMargin RedFont">
            {errors.MobileNo}
          </div>
        )}

        {/* <label className={posts.isSuccess + " d-flex justify-content-center"}>
          Success
        </label> */}

        <Button className="Button11" onClick={() => SubmitData()}>
          Submit
        </Button>
      </Modal.Body>
    </Modal>
  );
}

export default CustomerAddress;
